import React from 'react'

const Ratio = () => {
  return (
    <div></div>
  )
}

export default Ratio;